const myDict = {
  ja: {
    'User does not exist.': 'ユーザーが存在しません。',
    'Incorrect username or password.': 'ユーザー名またはパスワードが違います。',
    'User is not confirmed.': '認証コードによるユーザ確認が完了していません。',
    'User already exists': 'ユーザーは既に存在します。',
    'Invalid verification code provided, please try again.': '入力された認証コードが無効です。もう一度お試しください。',
    'Invalid password format': 'パスワードのフォーマットが不正です。',
    'Account recovery requires verified contact information':
      'アカウントの復元には認証コードで確認済みの連絡先情報が必要です。',
    'Invalid phone number format': '電話番号の形式が無効です。次の形式で入力してください: +12345678900',
    'An account with the given email already exists.': '入力されたメールアドレスは既に存在します。',
    'Username cannot be empty': 'ユーザー名は必須です。',
    'Password attempts exceeded':
      'パスワードの入力エラー回数が所定の回数を超えました。システム管理者に連絡してください。',
    'Attempt limit exceeded, please try after some time.':
      'パスワードの入力エラー回数が所定の回数を超えました。しばらくしてからもう一度お試しください。',
    'Username/client id combination not found.': 'ユーザーが存在しません。',
    'CUSTOM_AUTH is not enabled for the client.': 'パスワードは必須です。', // 本来の意味とは異なるが、パスワード未入力時に発生するのでこの訳としている
    'Password does not conform to policy: Password not long enough': 'パスワードは8文字以上を入力してください。', // 適宜修正
    'Password does not conform to policy: Password must have uppercase characters':
      'パスワードには大文字を含めてください。', // 適宜修正
    'Password does not conform to policy: Password must have lowercase characters':
      'パスワードには小文字を含めてください。', // 適宜修正
    'Password does not conform to policy: Password must have numeric characters':
      'パスワードには数字を含めてください。', // 適宜修正
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
      'パスワードは8文字以上、大文字小文字を含む英数字を指定してください。', // 適宜修正。本来の意味とは異なるがこれで明示している。
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[S]+.*[S]+$":
      'パスワードは8文字以上、大文字小文字を含む英数字を指定してください。', // 適宜修正。本来の意味とは異なるがこれで明示している。
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$":
      'パスワードの値が条件を満たしていません。',
    'Cannot reset password for the user as there is no registered/verified email or phone_number':
      '登録済みのメールアドレスを入力してください。',
    'username is required to signIn': 'ログインIDは必須です。',
    'password is required to signIn': 'パスワードは必須です。',
  },
};

export default myDict;
